import type {ThemeBase} from 'config/themes/base';
import light from 'config/themes/light';

export const theme: ThemeBase = light;
